export default {
  //授课签到
  SKSignAdd:'',
  SKSignStuList:'',
  SKSignList: '',
  SKSignOn:'',
  SKSignDetail:'',
  SKSignEdit:'',
  SKSignStuEdit:'',
  SKSignStuBatchEdit:'',
}
